// PatientDetails.js
import React from 'react';
import api from './api';
import './Doctors.css';
import PreConsultation from './PreConsultation';
import PostConsultation from './PostConsultation';
import PatientSequences from './PatientSequences';
import SlidingDrawer from './SlidingDrawer';
import './SlidingDrawer.css';
import AuthContext from '../context/AuthProvider';
import { canDo } from '../utils/canDo';
import SessionIpadView from './SessionIpadView';
import ConsultationIpadView from './ConsultationIpadView';
import LabReadingsView from './LabReadingsView';
import PatientFiles from './PatientFiles';
import SafeImage from './SafeImage';

class PatientDetails extends React.Component {
     static contextType = AuthContext;
  constructor(props) {
    super(props);
    this.state = {
      healthDetails: [],
      paymentDetails: [],
      packages: [],
      patientHistory: [],
      activeTab: 0,
      showSessionCommentDrawer: false,
    };
  }

  componentDidMount() {
    console.log("props = ", this.props);
    console.log("props = ", this.context);
    const patientCard = this.props.patientData?.patientCard;
    const tabToSelect = this.props?.tabToSelect || 'PostConsultation';
    const isOwner = this.props.isOnwer;

    const roles = this.context?.auth?.roles || [];

    const isTherapistView = this.props?.isTherapistView;

    console.log("isTherapistView = ", isTherapistView);

  // Map string tab names to numeric tab index
  const tabMap = {
    'PreConsultation':  0,
    'ConsultationView': 1,
    'PostConsultation': 2,
    'PatientSequences': 3,
    'ViewSession':      4,
    'LabReadings':      5,
    'PatientFiles':     6,
    // legacy aliases
    'Consultation':     1,
  };

  const tabMapTherapist = {
    'ConsultationView': 1,
    'PostConsultation': 2,
    'PatientSequences': 3,
    'ViewSession':      4,
    'LabReadings':      5,
    'PatientFiles':     6,
  };

  const selectedMap = (isOwner ? tabMap : (isTherapistView ? tabMapTherapist : tabMap));

  const mappedTab = selectedMap[tabToSelect];
  if (typeof mappedTab === 'number') {
    this.setState({ activeTab: mappedTab });
  }

    const baseURL = process.env.REACT_APP_URL;

    if (!patientCard) return;
  }


  componentDidUpdate(prevProps, prevState) {
    // iOS12-compatible drawer scroll-lock logic
    if (prevState.showSessionCommentDrawer !== this.state.showSessionCommentDrawer) {
      document.body.style.overflow = this.state.showSessionCommentDrawer ? 'hidden' : '';
    }
  }

  setActiveTab = (index) => {
    this.setState({ activeTab: index });
  };

  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    } else if (this.props.navigate) {
      this.props.navigate('/ListPatients');
    }
  };

  renderTabButton(label, index) {
    const isActive = this.state.activeTab === index;
    return (
      <button
        key={index}
        onClick={() => this.setActiveTab(index)}
        style={{
          padding: '8px 16px',
          marginRight: 4,
          background: 'none',
          border: 'none',
          borderBottom: isActive ? '2.5px solid #2563eb' : '2.5px solid transparent',
          color: isActive ? '#2563eb' : '#6b7280',
          fontWeight: isActive ? 700 : 500,
          fontSize: 13,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
          borderRadius: 0,
          paddingBottom: 10,
          transition: 'color 0.15s, border-color 0.15s',
          marginTop: 0,
        }}
      >
        {label}
      </button>
    );
  }

  renderTabContent() {
    const { activeTab } = this.state;
    const { patientData } = this.props;

    const canViewPreConsultation = canDo(this.context?.auth, 'consultation.view');

    switch (activeTab) {
      case 0:
        if (!canViewPreConsultation) return <div style={{ padding: 24, color: '#888' }}>You do not have permission to view Pre Consultation records.</div>;
        return <PreConsultation patientCard={patientData.patientCard} onTabClose={this.handleClose} />;
      case 1:
        return <ConsultationIpadView patientCard={patientData.patientCard} activeTab={this.state.activeTab} />;
      case 2:
        return <PostConsultation patientCard={patientData.patientCard} patientFData={this.props.patientData} />;
      case 3:
        //return <PatientSequences patientCard={patientData.patientCard} activeTab={this.state.activeTab} />;
      case 4:
        return <SessionIpadView patientCard={patientData.patientCard} activeTab={this.state.activeTab} />;
      case 5:
        return <LabReadingsView patientCard={patientData.patientCard} />;
      case 6:
        return <PatientFiles patientCard={patientData.patientCard} patientPic={patientData.pic} />;
      default:
        return null;
    }
  }

  fetchPatientSessionComments = async () => {
    const patientCard = this.props.patientData && this.props.patientData.patientCard;
    if (!patientCard) return [];
    const resp = await api.get(`${process.env.REACT_APP_URL}/appointments/patient/${patientCard}/today`);
    const results = resp.data || [];

    // Convert with safer syntax (no optional chaining)
    return results.map(function(app) {
      var comment = (app && app.sessionComments) ? app.sessionComments : "No Comments";
      var from = (app && app.username) ? app.username : "-";
      var status = (app && app.status) ? app.status : "-";
      var dateVal = "-";
      if (app && app.start) {
        var d = new Date(app.start);
        if (!isNaN(d.getTime())) {
          // Format is locale-dependent; using en-GB here
          dateVal = d.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric'
          });
        }
      }
      return {
        comment: comment,
        from: from,
        status: status,
        date: dateVal,
      };
    });
  };

  renderSessionComment = (item) => {
    return (
      <div style={{ marginBottom: 14, padding: '10px 12px', background: '#f9fafb', borderRadius: 8, border: '1px solid #e5e7eb' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#6b7280', marginBottom: 3 }}>
          <span style={{ fontWeight: 600 }}>{item.date}</span>
          <span>{item.from}</span>
        </div>
        <div style={{ fontSize: 11, color: '#9ca3af', marginBottom: 4 }}>
          <span style={{
            display: 'inline-block', padding: '1px 8px', borderRadius: 99, fontSize: 10, fontWeight: 600,
            background: item.status === 'Completed' ? '#dcfce7' : item.status === 'inprogress' ? '#fef3c7' : '#f3f4f6',
            color: item.status === 'Completed' ? '#16a34a' : item.status === 'inprogress' ? '#d97706' : '#6b7280',
          }}>{item.status}</span>
        </div>
        <div style={{ whiteSpace: 'pre-wrap', fontWeight: 600, color: '#1f2937', fontSize: 13 }}>
          {item.comment}
        </div>
      </div>
    );
  };

  render() {
    const auth = this.context;
    const { patientData } = this.props;
    console.log("props patient =", patientData);
    if (!patientData) {
      return <div style={{ padding: 32, color: '#888', textAlign: 'center' }}>Loading patient details...</div>;
    }
    const isSuperAdmin = auth?.roles?.includes('superadmin');
    const isAdmin = auth?.roles?.includes('admin');
    const isTherapist = auth?.roles?.includes('therapist');

    const canViewPreConsultation = canDo(this.context?.auth, 'consultation.view');

    return (
      <div className="patient-main">
        <div style={{
          background: '#fff',
          borderRadius: 12,
          border: '1px solid #e5e7eb',
          boxShadow: '0 1px 8px rgba(0,0,0,0.07)',
          marginBottom: 0,
          minHeight: '80vh',
          width: '80vw',
          marginLeft: 10,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}>
          {/* Patient header bar — compact, single row */}
          {(() => {
            // Resolve pic URL: /pfiles/... paths need the server base; base64 / full URLs work as-is
            const rawPic = patientData.pic || '';
            const serverBase = (process.env.REACT_APP_URL || '').replace(/\/api$/, '');
            const picSrc = rawPic.startsWith('/pfiles') ? `${serverBase}${rawPic}` : rawPic;
            const initial = (patientData.name || '?')[0].toUpperCase();
            return (
              <div style={{
                background: 'linear-gradient(135deg, #1e3a5f 0%, #2563eb 100%)',
                padding: '0 16px',
                height: 44,
                display: 'flex',
                alignItems: 'center',
                gap: 10,
                flexShrink: 0,
              }}>
                {/* Profile thumbnail — pic if available, else initial */}
                {picSrc ? (
                  <SafeImage
                    src={picSrc}
                    alt={patientData.name}
                    style={{
                      width: 30, height: 30, borderRadius: '50%', flexShrink: 0,
                      objectFit: 'cover',
                      border: '2px solid rgba(255,255,255,0.4)',
                    }}
                  />
                ) : null}
                {/* Fallback initial — shown when no pic or pic fails to load */}
                <div style={{
                  width: 30, height: 30, borderRadius: '50%',
                  background: 'rgba(255,255,255,0.22)',
                  display: picSrc ? 'none' : 'flex',
                  alignItems: 'center', justifyContent: 'center',
                  fontSize: 12, fontWeight: 800, color: '#fff', flexShrink: 0,
                }}>
                  {initial}
                </div>
                {/* Name */}
                <span style={{ fontSize: 13, fontWeight: 700, color: '#fff', whiteSpace: 'nowrap' }}>
                  {patientData.name}
                </span>
                {/* Card chip */}
                <span style={{
                  fontSize: 11, fontWeight: 600,
                  background: 'rgba(255,255,255,0.15)',
                  color: 'rgba(255,255,255,0.9)',
                  borderRadius: 99, padding: '2px 9px',
                  whiteSpace: 'nowrap',
                }}>
                  {patientData.patientCard}
                </span>
                {/* Spacer */}
                <div style={{ flex: 1 }} />
                {/* Close × */}
                <button
                  onClick={this.handleClose}
                  title="Close patient"
                  style={{
                    marginLeft: 25,
                    width: 28, height: 28,
                    borderRadius: '50%',
                    background: 'rgba(255,255,255,0.15)',
                    border: '1px solid rgba(255,255,255,0.3)',
                    color: '#fff',
                    fontSize: 16, fontWeight: 700,
                    cursor: 'pointer',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    lineHeight: 1,
                    flexShrink: 0,
                  }}
                >
                  ×
                </button>
              </div>
            );
          })()}

          {/* Tab bar */}
          <div style={{
            display: 'flex',
            alignItems: 'flex-end',
            padding: '0 16px',
            borderBottom: '1px solid #e5e7eb',
            background: '#fff',
            overflowX: 'auto',
            WebkitOverflowScrolling: 'touch',
            flexShrink: 0,
          }}>
            {canViewPreConsultation && this.renderTabButton('Pre Consultation', 0)}
            {this.renderTabButton('Consultation View', 1)}
            {this.renderTabButton('Post Consultation', 2)}
            {this.renderTabButton('Session View', 4)}
            {this.renderTabButton('Lab Readings', 5)}
            {this.renderTabButton('Files & Docs', 6)}
          </div>

          {/* Tab content */}
          <div style={{ padding: '16px 20px', flex: 1, overflowY: 'auto' }}>
            {this.renderTabContent()}
          </div>
        </div>

        {!this.state.showSessionCommentDrawer && (
          <button
            className="floating-drawer-button"
            style={{ bottom: '25vh' }}
            onClick={() => this.setState({ showSessionCommentDrawer: true })}
          >
            📝 History
          </button>
        )}

        <SlidingDrawer
          isOpen={this.state.showSessionCommentDrawer}
          onClose={() => this.setState({ showSessionCommentDrawer: false })}
          header="📝 Past Sessions (60)"
          width={300}
          fetchData={this.fetchPatientSessionComments}
          renderItem={this.renderSessionComment}
        />
      </div>
    );
  }
}

export default PatientDetails;
